"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const security_error_1 = require("./security-error");
class TwingSandboxSecurityNotAllowedMethodError extends security_error_1.TwingSandboxSecurityError {
    constructor(message, className, methodName, lineno = -1, filename = null) {
        super(message, lineno, filename);
        this.className = className;
        this.methodName = methodName;
        this.name = 'TwingSandboxSecurityNotAllowedMethodError';
    }
    getClassName() {
        return this.className;
    }
    getMethodName() {
        return this.methodName;
    }
}
exports.TwingSandboxSecurityNotAllowedMethodError = TwingSandboxSecurityNotAllowedMethodError;
